<template>
  <vs-row vs-justify="center">
  <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
    <vs-card v-if="loaded">
      <div slot="header">
        <h3>
          TRANSACTION# {{ invoice.invoice.id }}
        </h3>
      </div>
      <div>
         <vs-list>
            <vs-list-item title="INVOICE DETAILS" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="ID">
              <p>{{ invoice.invoice.id }}</p>
            </vs-list-item>
            <vs-list-item title="Generated On">
              <p>{{ invoice.invoice.created_at }}</p>
            </vs-list-item>
            <vs-list-item title="Payment Date">
              <p v-if="invoice.invoice.cleared_on != null">{{ invoice.invoice.cleared_on }}</p>
              <p v-else>Not approved yet!</p>
            </vs-list-item>
            <vs-list-item title="Payment Method">
              <p>XXXX {{ invoice.buyer.card_no }}</p>
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="ORDER DETAILS" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="Type">
              <p><a v-if="invoice.invoice.invoice_type == 'Gig'" target="_blank" :href="`${site}/#/service/detail/${invoice.invoice.order_ref}`">Gig</a><a v-else target="_blank" :href="`${site}/#/projects/${invoice.job_link}`">Job</a></p>
            </vs-list-item>
            <vs-list-item title="Order ref">
              <p v-if="invoice.invoice.invoice_type == 'Job'">PR-{{ invoice.invoice.order_ref }}</p><p v-else>OR-{{ invoice.invoice.order_ref }}</p>
            </vs-list-item>
            <vs-list-item title="Order status">
              <p v-if="invoice.invoice.status == 'waiting'">Delivery in progress (expected delivery)</p>
              <p v-if="invoice.invoice.status == 'pending'">Delivery approved (amount in process)</p>
              <p v-if="invoice.invoice.status == 'cleared'">Delivery approved (amount released to seller)</p>
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="BUYER / SELLER DETAILS" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="Buyer">
              <p><a target="_blank" :href="`${site}/#/users/${invoice.buyer.id}`">@{{ invoice.buyer.username }}</a></p>
            </vs-list-item>
            <vs-list-item title="Seller">
              <p><a target="_blank" :href="`${site}/#/users/${invoice.seller.id}`">@{{ invoice.seller.username }}</a></p>
            </vs-list-item>
            <vs-list-item title="Buyer Invoice">
              <p>{{invoice.invoice.invoice_id_buyer}} <a target="_blank" :href="buyer_invoice()"><img src="/dl_invoice.png" width="20" /></a></p>
            </vs-list-item>
            <vs-list-item title="Seller Invoice">
              <p>{{invoice.invoice.invoice_id_seller}} <a target="_blank" :href="seller_invoice()"><img src="/dl_invoice.png" width="20" /></a></p>
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="AMOUNT DETAILS" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="Amount Of Buyer">
              <p>{{ invoice.invoice.amount_for_seller }} {{ invoice.invoice.currency }}</p>
            </vs-list-item>
            <vs-list-item title="Amount Of Seller">
              <p>{{ invoice.invoice.amount_for_buyer }} {{ invoice.invoice.currency }}</p>
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="COMMUNICATION HISTORY" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="Message Threads">
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item title="SELLER BANK DETAILS" style="text-decoration:underline;color:black;">
            </vs-list-item>
            <vs-list-item title="Bank Name">
              <p>{{ invoice.seller_bank && invoice.seller_bank.name }}</p>
            </vs-list-item>
            <vs-list-item title="Bank IBAN">
              <p>{{ invoice.seller_bank && invoice.seller_bank.iban }}</p>
            </vs-list-item>
            <vs-list-item title="Bank Swift">
              <p>{{ invoice.seller_bank && invoice.seller_bank.sift_bic }}</p>
            </vs-list-item>
            <vs-list-item title="">
            </vs-list-item>
            <vs-list-item v-if="invoice.invoice.status == 'pending'" :title="`RELEASE TIME: ${show_remaining(invoice.invoice.cleared_on)}`" style="text-decoration:underline;color:black;">
              <vs-button :disabled="release_date(invoice.invoice.cleared_on) < 0" style="margin-left:20px;" @click="confirm_release">RELEASE SELLER PAYMENT</vs-button>
            </vs-list-item>
            <vs-list-item v-if="invoice.invoice.status == 'cleared'" :title="`FUNDS CLEARED ${show_remaining(invoice.invoice.cleared_on)}`" style="text-decoration:underline;color:green;">
            </vs-list-item>

          </vs-list>
      </div>
    </vs-card>
  </vs-col>
</vs-row>
</template>
<script>
import moment from "moment"
import themeConfig from "../../../../themeConfig"
import moduleTransactionManagement from '@/store/transaction-management/moduleTransactionManagement.js'
export default {
  data(){
    return {
      invoice: {},
      loaded: false
    }
  },
  computed: {
    invoice_id(){
      return this.$router.history.current.params.id
    },
    site(){
      return themeConfig.MAIN_SITE
    }
  },
  created() {
    if(!moduleTransactionManagement.isRegistered) {
      this.$store.registerModule('transactionManagement', moduleTransactionManagement)
      moduleTransactionManagement.isRegistered = true
    }
    this.$store.dispatch("transactionManagement/fetchTransaction" , this.invoice_id ).then(res => {
      this.invoice = res.data
      this.loaded = true
    }).catch( () => {})

  },
  methods: {
    release_date( val ){

      if( val != null ){
        return moment().diff( moment(val) , 'days')
      }

    },
    show_remaining( val ){

      if( val != null ){
        return moment(val).fromNow()
      }

    },
    confirm_release() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Confirm payment release?`,
        text: `You are about to release payment of seller, this action cannot be undone`,
        accept: this.release_payment,
        acceptText: "Release"
      })
    },
    release_payment(){
      this.loaded = false
      this.$store.dispatch("transactionManagement/releaseFunds" , this.invoice_id ).then(res => {
        this.invoice = res.data
        this.loaded = true
      }).catch( () => {
        this.loaded = true
      })
    },
    seller_invoice(){
        return `${themeConfig.API_URL}/api/invoices/renderer?location=${this.makeFakeHash(600)}&_gZ=${this.invoice.invoice.id}&_v_mach=s__sAS`
    },
    buyer_invoice(){
        return `${themeConfig.API_URL}/api/invoices/renderer?location=${this.makeFakeHash(600)}&_gZ=${this.invoice.invoice.id}&_v_mach=s__sAP`
    },
    makeFakeHash(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!_-';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }
  }
}
</script>
<style>
.vs-list {
  margin-top: 25px;
}
.vs-list--item {
  border-bottom: none;
  font-size: 15px;
}
.vs-list--item .list-titles {
  width: 30%;
}
.vs-list--item .vs-list--slot {
  margin-left: 0px;
}
</style>
